import { VendorRepository } from "../../repositories/VendorRepository";
import {
  VendorOperationResult,
  VendorEntity,
} from "../../entities/VendorEntity";

/**
 * Update Vendor Use Case
 * Updates an existing vendor's information
 */
export class UpdateVendorUseCase {
  constructor(private repository: VendorRepository) {}

  async execute(
    vendorId: string,
    vendorData: Partial<VendorEntity>
  ): Promise<VendorOperationResult> {
    return await this.repository.updateVendor(vendorId, vendorData);
  }
}
